module.exports = __webpack_public_path__ + "img/bg_sec03_2_m.6f354b8e.jpg";